import React from 'react';
import { List, Paper } from '@mui/material';
import ListFileItem from './ListFileItem';
import { FileMetadata } from '../../api/types/cms';
import { useFileDialog } from './CmsFileDialogs';

type ListFileListProps = {
    items: Array<FileMetadata>;
    onClick?: (file: FileMetadata) => void;
    selectedFiles?: Array<FileMetadata>;
};

export default function ListFileList({
    items,
    onClick = () => {},
    selectedFiles = [],
}: ListFileListProps) {
    const { openFileDeleteDialog } = useFileDialog();

    const renderFileListItem = (item: FileMetadata, index: number) => (
        <ListFileItem
            key={item.id}
            file={item}
            actionsEnabled={true}
            active={Boolean(selectedFiles?.find((i: FileMetadata | string) => {
                if (typeof i === "string") {
                    return i === item.id;
                }
                return i.id === item.id
            }))}
            onItemClick={onClick}
            onDelete={openFileDeleteDialog}
        />
    );

    return (
        <Paper>
            <List component="div" dense={true}>
                {items.map(renderFileListItem)}
            </List>
        </Paper>
    );
}
